module.exports = __webpack_public_path__ + "img/summary-4.67a71c9a.svg";